<div fxFlexFill fxLayout="column">
    <span fxLayout="row" class="header">
        <span fxFlex fxLayoutAlign="center center">
            <span class="compliance-status medium" ngClass.xs="compliance-status xs-font medium">
            </span>
        </span>
        <span style="position: inline;right:0;">
            <a class="close regular" (click)="onClose()">{{'close' | transloco}}</a>
        </span>
    </span>
    <mat-dialog-content>
        <div>
            <img [src]="'data:image/jpeg;base64,'+imageSelected" height="100%" width="100%" />
        </div>
    </mat-dialog-content>
</div>